import { FurnitureAndPersonalEffectsValueSchema, FurnitureProps_1, TextInput, useNames } from "@fla/components";
import { yupResolver } from "@hookform/resolvers/yup";
import { selectConsentOrdersBase } from "pages/ConsentOrders";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

interface IProps {
  formId: string;
  store: FurnitureProps_1;
  onSubmit: (values: FurnitureProps_1) => void;
}
const Step03: FC<IProps> = ({ formId, store, onSubmit }) => {
  const { initialDetails } = useSelector(selectConsentOrdersBase);
  const { spouseFirstName } = useNames({ initialDetails });

  const { handleSubmit, control } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(FurnitureAndPersonalEffectsValueSchema)
  });

  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <TextInput
        title={`What is the approx value of the furniture & personal effects that you will be keeping?`}
        name="user_value"
        id="user_value"
        control={control}
        isAmount
        subTitle="Don’t include the values of any items of furniture/property you listed previously"
        subTitleClasses="text-red-500"
        theme="dark"
      />

      <TextInput
        title={`What is the approx value of the furniture & personal effects that ${spouseFirstName} will be keeping?`}
        name="spouse_value"
        id="spouse_value"
        control={control}
        isAmount
        subTitle="Don’t include the values of any items of furniture/property you listed previously"
        subTitleClasses="text-red-500"
        theme="dark"
      />
    </form>
  );
};
export default Step03;
